import React from 'react';
import {
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  ChipField,
  Datagrid,
  DateField,
  List,
  NullableBooleanInput,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  SingleFieldList,
  TextField,
  TextInput,
  TopToolbar,
  UrlField,
  useGetOne,
  useRecordContext,
} from 'react-admin';
import { TextFieldProps, Typography } from '@mui/material';
import { PriceField } from '../components/PriceField';
import { ContractTotalField } from './ContractTotalField';
import { Funeral } from '../types';
import { ReferenceManyToManyField } from '@react-admin/ra-relationships';
import { ContractPaymentsField } from './ContractPaymentsField';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import PrintPositiveInvoicesButton from '../invoices/PrintPositiveInvoicesButton';


const ContractListToolbar = () => {
  return (
    <TopToolbar>
        <PrintPositiveInvoicesButton />
    </TopToolbar>
  );
};

export const ContractList = () => (
  <List filters={searchFilters} sort={{ field: 'list_date', order: 'DESC' }} perPage={50} hasCreate={false} 
    actions={<ContractListToolbar />}>
    <Datagrid rowClick="show">
      {/* <TextField source="id" label="Contract ID" /> */}
      <ReferenceField source="funeral_id" reference="funerals" label="Funeral ID" link="show">
        <TextField source="id" />
      </ReferenceField>
      <ReferenceField source="funeral_id" reference="funerals" label="Deceased" link={false}>
        <ReferenceField source="deceased_client_id" reference="clients" link={false} >
          <TextField source="name" />
        </ReferenceField>
      </ReferenceField>
      <ReferenceField source="funeral_id" reference="funerals" label="Primary Client" link={false}>
        <ReferenceField source="primary_client_id" reference="clients" link={false}>
          <TextField source="name" />
        </ReferenceField>
      </ReferenceField>
      {/* <ReferenceManyField
        label="Invoice"
        target="contract_id"
        reference="sb_invoices"
      >
        <SingleFieldList linkType={false}>
          <ChipField source="accounting_doc_number" size='small' sx={{ backgroundColor: '#BFE1D5', color: 'black' }} />
        </SingleFieldList>
      </ReferenceManyField>
      <ReferenceManyField
        label="Credit"
        target="contract_id"
        reference="sb_creditmemos"
      >

        <SingleFieldList linkType={false}>
          <ChipField source="id" size='small' sx={{ backgroundColor: '#F9B7B5', color: 'black' }} />
        </SingleFieldList>
      </ReferenceManyField> */}
      <ReferenceField source="funeral_id" reference="funerals" label="Payments" link={false}>
        <ReferenceField source='primary_client_id' reference='clients' label="Payments" link={false}>
              <ReferenceField
                source="accounting_reference_id"
                reference="customers"
                link={false}
              >
                <QuickbooksPriceField source="Balance" />
              </ReferenceField>
          </ReferenceField>
        </ReferenceField>

      {/* <ContractPaymentsField label="Payments" /> */}
      {/* <ContractTotalField source="total_amount" /> */}
      {/* <UrlField source="signed_contract" target="_blank" /> */}
      {/* <DateField source="created_at" /> */}
      
      <BooleanField source="is_preneed" label="Pre-Need" />
    </Datagrid>
  </List>
);

const DaysSinceFuneral = (props: TextFieldProps) => {
  const record = useRecordContext();
  if (record.funeral_date == null) { return null; }

  const today = new Date(Date.now());
  const funeralDate = new Date(record.funeral_date);
  const difference_in_days = Math.floor((today.getTime() - funeralDate.getTime()) / (1000 * 3600 * 24));
  return <Typography>{difference_in_days}</Typography>
}

const searchFilters = [
  // <ReferenceInput source="client_id" reference="clients" alwaysOn>
  //   <AutocompleteInput
  //     optionText="name"
  //     filterToQuery={(searchText) => ({ 'name@ilike': searchText })}
  //     label="resources.contracts.search.client"
  //     fullWidth
  //   />
  // </ReferenceInput>,
  //   <ReferenceInput source="deceased_client_id" reference="clients" alwaysOn>
  //     <AutocompleteInput
  //       optionText="name"
  //       filterToQuery={(searchText) => ({ 'name@ilike': searchText })}
  //       label="resources.contracts.search.deceased_client"
  //       fullWidth
  //     />
  //   </ReferenceInput>,
  <NullableBooleanInput source="is_preneed" label="Pre-Need" alwaysOn />
];
